module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/bari.ad1462016933c872386f640d6ec9c0d3.jpg";